import heroBackground from './images/hero-bg.jpg';
import farmField from './images/farm-field.jpg';
import rice from './images/rice.jpg';
import wheat from './images/wheat.jpg';
import pumpkin from './images/pumpkin.jpg';
import cabbage from './images/cabbage.jpg';
import tractorSunset from './images/tractor-sunset.jpg';
import innovation from './images/innovation.jpg';
import analytics from './images/analytics.jpg';
import sustainable from './images/sustainable.jpg';
import testimonial1 from './images/testimonial-1.jpg';

export const images = {
  heroBackground,
  farmField,
  rice,
  wheat,
  pumpkin,
  cabbage,
  tractorSunset,
  innovation,
  analytics,
  sustainable,
  testimonial1,
} as const;

export default images; 